import { render, staticRenderFns } from "./UserComment.vue?vue&type=template&id=744f7e23&"
import script from "./UserComment.vue?vue&type=script&lang=js&"
export * from "./UserComment.vue?vue&type=script&lang=js&"
import style0 from "./UserComment.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "UserComment.vue"
export default component.exports